import { defineMessages } from 'react-intl';

export default defineMessages({
    baVehicleTitle: {
        id: 'quoteandbind.ba.views.ba-vehicle-details.Vehicle',
        defaultMessage: 'Vehicle',
    },
    baVehicleTitleNumber: {
        id: 'quoteandbind.ba.views.ba-vehicle-details.Vehicle:',
        defaultMessage: 'Vehicle:',
    },
    baAddAnotherVehicleTitle: {
        id: 'quoteandbind.ba.views.ba-driver-details.Add Another Vehicle?',
        defaultMessage: 'Add Another Vehicle?',
    },
    baAddDriverButtonText: {
        id: 'quoteandbind.ba.views.ba-driver-details.Add Vehicle',
        defaultMessage: 'Add Vehicle',
    },
    removeVehicleTitle: {
        id: 'quoteandbind.ba.controllers.baVehicleDetailsCtrl.Remove Vehicle?',
        defaultMessage: 'Remove Vehicle?',
    },
    removeVehicleDescription: {
        id: 'quoteandbind.ba.drivers.remove-vehicle.message',
        defaultMessage: 'Are you sure you want to remove this vehicle from the list of vehicles?',
    },
    fillInMsg: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-vehicle.fillInMsg',
        defaultMessage: 'After you enter a VIN and move to the next field, the Make, Model and Year fields will be filled in automatically if possible.',
    },
    additionalInterestsForThisVehicle: {
        id: 'quoteandbind.ba.views.ba-vehicle-details.Additional Interests for This Vehicle',
        defaultMessage: 'Additional Interests for This Vehicle',
    },
    baAddAdditionalInterestType: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Type',
        defaultMessage: 'Type',
    },
    baAddAdditionalInterestFirstName: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.First Name',
        defaultMessage: 'First Name',
    },
    baAddAdditionalInterestLastName: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Last Name',
        defaultMessage: 'Last Name',
    },
    baAddAdditionalInterestLastName: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Middle Name',
        defaultMessage: 'Middle Name',
    },
    baAddAdditionalInterestCountry: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Country',
        defaultMessage: 'Country',
    },
    baAddAdditionalInterestAddress: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Address',
        defaultMessage: 'Address',
    },
    baAddAdditionalInterestCity: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.City',
        defaultMessage: 'City',
    },
    baAddAdditionalInterestState: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.State',
        defaultMessage: 'State',
    },
    baAddAdditionalInterestZipCode: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.ZIP Code',
        defaultMessage: 'ZIP code',
    },
    baAddAdditionalInterestInterestType: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Interest Type',
        defaultMessage: 'Interest Type',
    },
    baAddAdditionalInterestAddressType: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Address Type',
        defaultMessage: 'Address Type',
    },
    baAddAdditionalInterestPhoneNumber: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Phone Number',
        defaultMessage: 'Phone Number',
    },
    baAddAdditionalInterestEmail: {
        id: 'quoteandbind.views.ba-your-home.additional-interest.Email',
        defaultMessage: 'Email',
    },
    baAddAdditionalInterestForThisVehicle: {
        id: 'quoteandbind.ba.views.ba-driver-details.Additional Interests for This Vehicle',
        defaultMessage: 'Additional Interests for This Vehicle',
    },
    additionalInterestCount: {
        id: 'quoteandbind.views.ba-vehicles.additional-interest.Additional Interest:',
        defaultMessage: 'Additional Interest: { count }'
    },
    baAddAdditionalInterest: {
        id: 'quoteandbind.ba.views.ba-driver-details.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
});
